import { createClient, SupabaseClient } from '@supabase/supabase-js';
export const AUTH_STORAGE_KEY = 'bottom-up-auth-session';

export const supabase = createClient(
    import.meta.env.VITE_SUPABASE_URL!,
    import.meta.env.VITE_SUPABASE_ANON_KEY!,{
        auth: {
            storageKey: AUTH_STORAGE_KEY,autoRefreshToken: true,persistSession: true,
        }
    }
) as SupabaseClient;

